import { action } from "satcheljs";
import type { SearchTab } from "owa-search-types/lib/types/SearchTab";
import type { PerformanceDatapoint } from "owa-analytics";
import type { Refiner } from "owa-search-types";

/**
 * Action which kicks off a 3S search query for a given non-mail tab
 */
export interface Invoke3sSearchForTabActionMessage {
    tab: SearchTab;
    queryString: string;
    searchEndToEndDatapoint: PerformanceDatapoint;
    appliedRefinersCount: number;
    appliedRefiners: Refiner[];
}
export const invoke3sSearchForTab: (tab: SearchTab, queryString: string, searchEndToEndDatapoint: PerformanceDatapoint, appliedRefinersCount: number, appliedRefiners: Refiner[]) => Invoke3sSearchForTabActionMessage = action("invoke3sSearchForTab", (tab: SearchTab, queryString: string, searchEndToEndDatapoint: PerformanceDatapoint, appliedRefinersCount: number, appliedRefiners: Refiner[]): Invoke3sSearchForTabActionMessage => ({
    tab,
    queryString,
    searchEndToEndDatapoint,
    appliedRefinersCount,
    appliedRefiners,
}));
